// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-43230e98] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/* Default global values */
button[data-v-43230e98]:not(.button-vue),
input[data-v-43230e98]:not([type=range]),
textarea[data-v-43230e98] {
  margin: 0;
  padding: 7px 6px;
  cursor: text;
  color: var(--color-main-text);
  border: 1px solid var(--color-border-dark);
  border-radius: var(--border-radius-element);
  outline: none;
  background-color: var(--color-main-background);
  font-size: 13px;
}
button[data-v-43230e98]:not(.button-vue):not(:disabled):not(.primary):hover, button[data-v-43230e98]:not(.button-vue):not(:disabled):not(.primary):focus, button:not(.button-vue):not(:disabled):not(.primary).active[data-v-43230e98],
input[data-v-43230e98]:not([type=range]):not(:disabled):not(.primary):hover,
input[data-v-43230e98]:not([type=range]):not(:disabled):not(.primary):focus,
input:not([type=range]):not(:disabled):not(.primary).active[data-v-43230e98],
textarea[data-v-43230e98]:not(:disabled):not(.primary):hover,
textarea[data-v-43230e98]:not(:disabled):not(.primary):focus,
textarea:not(:disabled):not(.primary).active[data-v-43230e98] {
  /* active class used for multiselect */
  border-color: var(--color-primary-element);
  outline: none;
}
button[data-v-43230e98]:not(.button-vue):not(:disabled):not(.primary):active,
input[data-v-43230e98]:not([type=range]):not(:disabled):not(.primary):active,
textarea[data-v-43230e98]:not(:disabled):not(.primary):active {
  color: var(--color-main-text);
  outline: none;
  background-color: var(--color-main-background);
}
button[data-v-43230e98]:not(.button-vue):disabled,
input[data-v-43230e98]:not([type=range]):disabled,
textarea[data-v-43230e98]:disabled {
  cursor: default;
  opacity: 0.5;
  color: var(--color-text-maxcontrast);
  background-color: var(--color-background-dark);
}
button[data-v-43230e98]:not(.button-vue):required,
input[data-v-43230e98]:not([type=range]):required,
textarea[data-v-43230e98]:required {
  box-shadow: none;
}
button[data-v-43230e98]:not(.button-vue):invalid,
input[data-v-43230e98]:not([type=range]):invalid,
textarea[data-v-43230e98]:invalid {
  border-color: var(--color-border-error, var(--color-error));
  box-shadow: none !important;
}
button[data-v-43230e98]:not(.button-vue),
input[data-v-43230e98]:not([type=range]),
textarea[data-v-43230e98] {
  /* Primary action button, use sparingly */
}
button:not(.button-vue).primary[data-v-43230e98],
input:not([type=range]).primary[data-v-43230e98],
textarea.primary[data-v-43230e98] {
  cursor: pointer;
  color: var(--color-primary-element-text);
  border-color: var(--color-primary-element);
  background-color: var(--color-primary-element);
}
button:not(.button-vue).primary[data-v-43230e98]:not(:disabled):hover, button:not(.button-vue).primary[data-v-43230e98]:not(:disabled):focus, button:not(.button-vue).primary[data-v-43230e98]:not(:disabled):active,
input:not([type=range]).primary[data-v-43230e98]:not(:disabled):hover,
input:not([type=range]).primary[data-v-43230e98]:not(:disabled):focus,
input:not([type=range]).primary[data-v-43230e98]:not(:disabled):active,
textarea.primary[data-v-43230e98]:not(:disabled):hover,
textarea.primary[data-v-43230e98]:not(:disabled):focus,
textarea.primary[data-v-43230e98]:not(:disabled):active {
  border-color: var(--color-primary-element-light);
  background-color: var(--color-primary-element-light);
}
button:not(.button-vue).primary[data-v-43230e98]:not(:disabled):active,
input:not([type=range]).primary[data-v-43230e98]:not(:disabled):active,
textarea.primary[data-v-43230e98]:not(:disabled):active {
  color: var(--color-primary-element-text-dark);
}
button:not(.button-vue).primary[data-v-43230e98]:disabled,
input:not([type=range]).primary[data-v-43230e98]:disabled,
textarea.primary[data-v-43230e98]:disabled {
  cursor: default;
  color: var(--color-primary-element-text-dark);
  background-color: var(--color-primary-element);
}

/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
li.action[data-v-43230e98]:hover, li.action.active[data-v-43230e98] {
  border-radius: 6px;
  padding: 0;
}
li.action[data-v-43230e98]:hover {
  background-color: var(--color-background-hover);
}
.action--disabled[data-v-43230e98] {
  pointer-events: none;
  opacity: 0.5;
}
.action--disabled[data-v-43230e98]:hover, .action--disabled[data-v-43230e98]:focus {
  cursor: default;
  opacity: 0.5;
}
.action--disabled[data-v-43230e98] * {
  opacity: 1 !important;
}
.action-input[data-v-43230e98] {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
  color: var(--color-main-text);
  border: 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  font-weight: var(--font-weight-default, normal);
}
.action-input__icon-wrapper[data-v-43230e98] {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
}
.action-input__icon-wrapper[data-v-43230e98] .material-design-icon {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  opacity: 1;
}
.action-input__icon-wrapper[data-v-43230e98] .material-design-icon .material-design-icon__svg {
  vertical-align: middle;
}
.action-input > span[data-v-43230e98] {
  cursor: pointer;
  white-space: nowrap;
}
.action-input__icon[data-v-43230e98] {
  min-width: 0; /* Overwrite icons*/
  min-height: 0;
  padding: calc(var(--default-clickable-area) / 2) 0 calc(var(--default-clickable-area) / 2) var(--default-clickable-area);
  background-position: calc((var(--default-clickable-area) - 16px) / 2) center;
  background-size: 16px;
}
.action-input__form[data-v-43230e98] {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  margin: 4px 0;
  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2);
}
.action-input__container[data-v-43230e98] {
  position: relative;
  width: 100%;
}
.action-input__input-container[data-v-43230e98] {
  display: flex;
}
.action-input__input-container .colorpicker__trigger[data-v-43230e98], .action-input__input-container .colorpicker__preview[data-v-43230e98] {
  width: 100%;
}
.action-input__input-container .colorpicker__preview[data-v-43230e98] {
  width: 100%;
  height: 36px;
  border-radius: var(--border-radius-element);
  border: 2px solid var(--color-border-maxcontrast);
  box-shadow: none !important;
}
.action-input__text-label[data-v-43230e98] {
  padding: 4px 0;
  display: block;
}
.action-input__text-label--hidden[data-v-43230e98] {
  position: absolute;
  inset-inline-start: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -1;
  opacity: 0;
}
.action-input__datetimepicker[data-v-43230e98] {
  width: 100%;
}
.action-input__datetimepicker[data-v-43230e98] .mx-input {
  margin: 0;
}
.action-input__multi[data-v-43230e98] {
  width: 100%;
}
li:last-child > .action-input[data-v-43230e98] {
  padding-bottom: calc((var(--default-clickable-area) - 16px) / 2 - 4px);
}
li:first-child > .action-input[data-v-43230e98]:not(.action-input--visible-label) {
  padding-top: calc((var(--default-clickable-area) - 16px) / 2 - 4px);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcActionInput-t9WvlgV0.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE;AACF,0BAA0B;AAC1B;;;EAGE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,8CAA8C;EAC9C,eAAe;AACjB;AACA;;;;;;;EAOE,sCAAsC;EACtC,0CAA0C;EAC1C,aAAa;AACf;AACA;;;EAGE,6BAA6B;EAC7B,aAAa;EACb,8CAA8C;AAChD;AACA;;;EAGE,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,8CAA8C;AAChD;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,2DAA2D;EAC3D,2BAA2B;AAC7B;AACA;;;EAGE,yCAAyC;AAC3C;AACA;;;EAGE,eAAe;EACf,wCAAwC;EACxC,0CAA0C;EAC1C,8CAA8C;AAChD;AACA;;;;;;;EAOE,gDAAgD;EAChD,oDAAoD;AACtD;AACA;;;EAGE,6CAA6C;AAC/C;AACA;;;EAGE,eAAe;EACf,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,+CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,wHAAwH;EACxH,4EAA4E;EAC5E,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,oEAAoE;AACtE;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,iDAAiD;EACjD,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,sEAAsE;AACxE;AACA;EACE,mEAAmE;AACrE","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-43230e98] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/* Default global values */\nbutton[data-v-43230e98]:not(.button-vue),\ninput[data-v-43230e98]:not([type=range]),\ntextarea[data-v-43230e98] {\n  margin: 0;\n  padding: 7px 6px;\n  cursor: text;\n  color: var(--color-main-text);\n  border: 1px solid var(--color-border-dark);\n  border-radius: var(--border-radius-element);\n  outline: none;\n  background-color: var(--color-main-background);\n  font-size: 13px;\n}\nbutton[data-v-43230e98]:not(.button-vue):not(:disabled):not(.primary):hover, button[data-v-43230e98]:not(.button-vue):not(:disabled):not(.primary):focus, button:not(.button-vue):not(:disabled):not(.primary).active[data-v-43230e98],\ninput[data-v-43230e98]:not([type=range]):not(:disabled):not(.primary):hover,\ninput[data-v-43230e98]:not([type=range]):not(:disabled):not(.primary):focus,\ninput:not([type=range]):not(:disabled):not(.primary).active[data-v-43230e98],\ntextarea[data-v-43230e98]:not(:disabled):not(.primary):hover,\ntextarea[data-v-43230e98]:not(:disabled):not(.primary):focus,\ntextarea:not(:disabled):not(.primary).active[data-v-43230e98] {\n  /* active class used for multiselect */\n  border-color: var(--color-primary-element);\n  outline: none;\n}\nbutton[data-v-43230e98]:not(.button-vue):not(:disabled):not(.primary):active,\ninput[data-v-43230e98]:not([type=range]):not(:disabled):not(.primary):active,\ntextarea[data-v-43230e98]:not(:disabled):not(.primary):active {\n  color: var(--color-main-text);\n  outline: none;\n  background-color: var(--color-main-background);\n}\nbutton[data-v-43230e98]:not(.button-vue):disabled,\ninput[data-v-43230e98]:not([type=range]):disabled,\ntextarea[data-v-43230e98]:disabled {\n  cursor: default;\n  opacity: 0.5;\n  color: var(--color-text-maxcontrast);\n  background-color: var(--color-background-dark);\n}\nbutton[data-v-43230e98]:not(.button-vue):required,\ninput[data-v-43230e98]:not([type=range]):required,\ntextarea[data-v-43230e98]:required {\n  box-shadow: none;\n}\nbutton[data-v-43230e98]:not(.button-vue):invalid,\ninput[data-v-43230e98]:not([type=range]):invalid,\ntextarea[data-v-43230e98]:invalid {\n  border-color: var(--color-border-error, var(--color-error));\n  box-shadow: none !important;\n}\nbutton[data-v-43230e98]:not(.button-vue),\ninput[data-v-43230e98]:not([type=range]),\ntextarea[data-v-43230e98] {\n  /* Primary action button, use sparingly */\n}\nbutton:not(.button-vue).primary[data-v-43230e98],\ninput:not([type=range]).primary[data-v-43230e98],\ntextarea.primary[data-v-43230e98] {\n  cursor: pointer;\n  color: var(--color-primary-element-text);\n  border-color: var(--color-primary-element);\n  background-color: var(--color-primary-element);\n}\nbutton:not(.button-vue).primary[data-v-43230e98]:not(:disabled):hover, button:not(.button-vue).primary[data-v-43230e98]:not(:disabled):focus, button:not(.button-vue).primary[data-v-43230e98]:not(:disabled):active,\ninput:not([type=range]).primary[data-v-43230e98]:not(:disabled):hover,\ninput:not([type=range]).primary[data-v-43230e98]:not(:disabled):focus,\ninput:not([type=range]).primary[data-v-43230e98]:not(:disabled):active,\ntextarea.primary[data-v-43230e98]:not(:disabled):hover,\ntextarea.primary[data-v-43230e98]:not(:disabled):focus,\ntextarea.primary[data-v-43230e98]:not(:disabled):active {\n  border-color: var(--color-primary-element-light);\n  background-color: var(--color-primary-element-light);\n}\nbutton:not(.button-vue).primary[data-v-43230e98]:not(:disabled):active,\ninput:not([type=range]).primary[data-v-43230e98]:not(:disabled):active,\ntextarea.primary[data-v-43230e98]:not(:disabled):active {\n  color: var(--color-primary-element-text-dark);\n}\nbutton:not(.button-vue).primary[data-v-43230e98]:disabled,\ninput:not([type=range]).primary[data-v-43230e98]:disabled,\ntextarea.primary[data-v-43230e98]:disabled {\n  cursor: default;\n  color: var(--color-primary-element-text-dark);\n  background-color: var(--color-primary-element);\n}\n\n/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\nli.action[data-v-43230e98]:hover, li.action.active[data-v-43230e98] {\n  border-radius: 6px;\n  padding: 0;\n}\nli.action[data-v-43230e98]:hover {\n  background-color: var(--color-background-hover);\n}\n.action--disabled[data-v-43230e98] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.action--disabled[data-v-43230e98]:hover, .action--disabled[data-v-43230e98]:focus {\n  cursor: default;\n  opacity: 0.5;\n}\n.action--disabled[data-v-43230e98] * {\n  opacity: 1 !important;\n}\n.action-input[data-v-43230e98] {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  color: var(--color-main-text);\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: none;\n  font-weight: var(--font-weight-default, normal);\n}\n.action-input__icon-wrapper[data-v-43230e98] {\n  display: flex;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.action-input__icon-wrapper[data-v-43230e98] .material-design-icon {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  opacity: 1;\n}\n.action-input__icon-wrapper[data-v-43230e98] .material-design-icon .material-design-icon__svg {\n  vertical-align: middle;\n}\n.action-input > span[data-v-43230e98] {\n  cursor: pointer;\n  white-space: nowrap;\n}\n.action-input__icon[data-v-43230e98] {\n  min-width: 0; /* Overwrite icons*/\n  min-height: 0;\n  padding: calc(var(--default-clickable-area) / 2) 0 calc(var(--default-clickable-area) / 2) var(--default-clickable-area);\n  background-position: calc((var(--default-clickable-area) - 16px) / 2) center;\n  background-size: 16px;\n}\n.action-input__form[data-v-43230e98] {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  margin: 4px 0;\n  padding-inline-end: calc((var(--default-clickable-area) - 16px) / 2);\n}\n.action-input__container[data-v-43230e98] {\n  position: relative;\n  width: 100%;\n}\n.action-input__input-container[data-v-43230e98] {\n  display: flex;\n}\n.action-input__input-container .colorpicker__trigger[data-v-43230e98], .action-input__input-container .colorpicker__preview[data-v-43230e98] {\n  width: 100%;\n}\n.action-input__input-container .colorpicker__preview[data-v-43230e98] {\n  width: 100%;\n  height: 36px;\n  border-radius: var(--border-radius-element);\n  border: 2px solid var(--color-border-maxcontrast);\n  box-shadow: none !important;\n}\n.action-input__text-label[data-v-43230e98] {\n  padding: 4px 0;\n  display: block;\n}\n.action-input__text-label--hidden[data-v-43230e98] {\n  position: absolute;\n  inset-inline-start: 0;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  opacity: 0;\n}\n.action-input__datetimepicker[data-v-43230e98] {\n  width: 100%;\n}\n.action-input__datetimepicker[data-v-43230e98] .mx-input {\n  margin: 0;\n}\n.action-input__multi[data-v-43230e98] {\n  width: 100%;\n}\nli:last-child > .action-input[data-v-43230e98] {\n  padding-bottom: calc((var(--default-clickable-area) - 16px) / 2 - 4px);\n}\nli:first-child > .action-input[data-v-43230e98]:not(.action-input--visible-label) {\n  padding-top: calc((var(--default-clickable-area) - 16px) / 2 - 4px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
